<template>
  <!-- Authors Table Card -->
  <div>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="12">
            <h5 class="font-semibold m-0">用户管理</h5>
          </a-col>
          <a-col :span="24" :md="12" style="
              display: flex;
              align-items: center;
              justify-content: flex-end;
              gap: 12px;
            ">
            <a-select 
              v-model="accountFilter" 
              placeholder="筛选账号类型" 
              style="width: 150px;"
              @change="onFilterChange"
            >
              <a-select-option value="all">全部账号</a-select-option>
              <a-select-option value="main">主账号</a-select-option>
              <a-select-option value="sub">子账号</a-select-option>
            </a-select>
            <a-button type="primary" class="add-shop" @click="openAddUser">
              新增用户
            </a-button>
          </a-col>
        </a-row>
      </template>
      <a-table :columns="columns" :data-source="filteredData" :pagination="true" :locale="tableLocale" :scroll="{ x: 1030 }">
        <template slot="username" slot-scope="username, record">
          <div class="username-info">
            <span class="username-text" :class="{ 'sub-account': record.is_sub }">
              {{ username }}
            </span>
          </div>
        </template>
        
        <template slot="accountType" slot-scope="text, record">
          <a-tag :color="record.is_sub ? 'orange' : 'blue'" class="account-type-tag">
            <a-icon :type="record.is_sub ? 'user' : 'crown'" />
            {{ record.is_sub ? '子账号' : '主账号' }}
          </a-tag>
          <a-tag v-if="!record.is_sub && record.account_type === 'agent'" color="purple" class="account-type-tag">
            <a-icon type="team" /> 代理
          </a-tag>
        </template>
        
        <template slot="parent" slot-scope="parent, record">
          <div class="parent-info">
            <span v-if="record.is_sub && record.parent" class="parent-username">
              {{ record.parent }}
            </span>
            <span v-else class="no-parent">-</span>
          </div>
        </template>
        
        <template slot="website" slot-scope="website">
          <div class="author-info">
            <div class="website-tags" v-if="domainList(website).length">
              <a-tag
                v-for="domain in visibleDomains(website)"
                :key="domain"
                class="website-tag"
                color="blue"
                :title="domain"
                @click="copyDomain(domain)"
              >
                {{ domain }}
              </a-tag>
              <!-- 多余域名折叠为「+N」，点击弹出完整列表，每项仍可点击复制，行为不变 -->
              <a-popover
                v-if="hiddenDomains(website).length"
                placement="topLeft"
                trigger="click"
              >
                <template slot="content">
                  <div class="website-overflow-pop">
                    <a-tag
                      v-for="domain in domainList(website)"
                      :key="domain"
                      class="website-tag"
                      color="blue"
                      :title="domain"
                      @click="copyDomain(domain)"
                    >
                      {{ domain }}
                    </a-tag>
                  </div>
                </template>
                <a-tag class="website-tag website-more-tag">
                  +{{ hiddenDomains(website).length }}
                </a-tag>
              </a-popover>
            </div>
            <span v-else class="no-parent">-</span>
          </div>
        </template>
        <template slot="expiry_time" slot-scope="expiry_time">
          <div class="author-info">
            <h6 class="m-0" :class="{ 'text-red': isExpiringSoon(expiry_time) }">{{ expiry_time }}</h6>
          </div>
        </template>


        <template slot="status" slot-scope="status">
          <a-tag class="tag-status" :class="status ? 'ant-tag-primary' : 'ant-tag-muted'">
            {{ status ? "有效" : "失效" }}
          </a-tag>
        </template>

        <template slot="editBtn" slot-scope="row">
          <div class="action-cell">
            <a-button type="link" :data-id="row.key" class="btn-edit action-link" @click="truePass(row)">
              真实密码
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit action-link" @click="openEdit(row)">
              编辑域名
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit action-link" @click="openEditPass(row)">
              修改密码
            </a-button>
            <a-button type="link" :data-id="row.key" class="btn-edit action-link" @click="openEditDays(row)">
              续期
            </a-button>
            <a-popconfirm title="把该用户今日 API 使用额度清 0?" ok-text="确定" cancel-text="取消" @confirm="doResetQuota(row)">
              <a-button type="link" :data-id="row.key" class="btn-edit action-link">
                重置额度
              </a-button>
            </a-popconfirm>
            <a-popconfirm title="确定要删除此用户吗?" ok-text="确定" cancel-text="取消" @confirm="deleteUser(row)">
              <a-button type="link" :data-id="row.key" class="action-link" style="color:red;">
                删除
              </a-button>
            </a-popconfirm>

          </div>
        </template>
      </a-table>
    </a-card>
    <!-- 新增用户 -->
    <a-modal v-model="modal2Visible" title="新增用户" centered :width="600" cancelText="取消" okText="确认" @ok="addUser">
      <a-form-model :model="form" layout="horizontal" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" class="au-form">
        <a-form-model-item label="账号类型">
          <a-radio-group v-model="form.is_sub" @change="onAccountTypeChange">
            <a-radio :value="false">主账号</a-radio>
            <a-radio :value="true">子账号</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="!form.is_sub" label="用户类型">
          <a-radio-group v-model="form.account_type">
            <a-radio value="normal">普通用户</a-radio>
            <a-radio value="agent">代理用户</a-radio>
          </a-radio-group>
          <div style="color:#999;font-size:12px;line-height:1.5;">代理用户将隐藏「订阅中心 / 账户充值 / 域名商城」，续费改为联系客服。</div>
        </a-form-model-item>
        <a-form-model-item v-if="form.is_sub" label="选择父账号">
          <a-select v-model="form.parent" placeholder="请选择父账号">
            <a-select-option v-for="user in mainAccounts" :key="user.username" :value="user.username">
              {{ user.username }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="用户昵称">
          <a-input v-model="form.username" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item ref="name" label="用户密码" prop="password">
          <div style="display:flex; gap:8px; align-items:center;">
            <a-input v-model="form.password" style="flex:1" placeholder="自动生成，可编辑" @blur="() => { $refs.name.onFieldBlur(); }" />
            <a-tooltip title="生成随机密码">
              <a-button @click="form.password = genPassword()"><a-icon type="reload" />随机</a-button>
            </a-tooltip>
            <a-button type="primary" ghost @click="copyLoginInfo(form.username, form.password)"><a-icon type="copy" />复制登录信息</a-button>
          </div>
        </a-form-model-item>
        <a-form-model-item label="套餐">
          <a-select v-model="form.plan" placeholder="请选择套餐（决定席位与 API 日额度）">
            <a-select-option v-for="p in plans" :key="p.code" :value="p.code">
              {{ p.name }}（{{ p.slot_total }} 席位 · {{ p.price_u }}U）
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="分配域名">
          <a-select v-model="form.website" placeholder="请选择分配域名" mode="multiple">
            <a-select-option v-for="domain in domains" :key="domain" :value="domain">
              {{ domain }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="到期时间">
          <div class="quick-time-btns">
            <a-button size="small" @click="setQuickTime('add', 0.5)">半天</a-button>
            <a-button size="small" @click="setQuickTime('add', 1)">1天</a-button>
            <a-button size="small" @click="setQuickTime('add', 7)">1周</a-button>
            <a-button size="small" @click="setQuickTime('add', 30)">1个月</a-button>
            <a-button size="small" @click="setQuickTime('add', 90)">3个月</a-button>
          </div>
          <a-date-picker v-model="date1" show-time type="date" placeholder="选择到期时间" style="width: 100%; margin-top: 8px;" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 分配域名 -->
    <a-modal v-model="editUserVisible" title="编辑用户" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item v-if="!editForm.is_sub" label="用户类型">
          <a-radio-group v-model="editForm.account_type">
            <a-radio value="normal">普通用户</a-radio>
            <a-radio value="agent">代理用户</a-radio>
          </a-radio-group>
          <div style="color:#999;font-size:12px;line-height:1.5;">代理用户将隐藏「订阅中心 / 账户充值 / 域名商城」，续费改为联系客服。</div>
        </a-form-model-item>
        <a-form-model-item label="分配域名">
          <a-select v-model="editForm.website" :value="editForm.website" placeholder="请选择分配域名" mode="multiple">
            <a-select-option v-for="domain in domains" :key="domain" :value="domain">
              {{ domain }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="批量新增">
          <a-textarea v-model="batchDomains" :rows="4" placeholder="一行一个域名，粘贴后点「加入授权」批量授权给该用户&#10;example1.com&#10;example2.com&#10;example3.com/kr" />
          <div style="display:flex;align-items:center;gap:10px;margin-top:6px;">
            <a-button type="primary" size="small" @click="batchAddDomains">加入授权</a-button>
            <span style="color:#999;font-size:12px;">一行一个，自动去重并合并到上方「分配域名」。</span>
          </div>
        </a-form-model-item>
        <a-form-model-item label="套餐">
          <a-select v-model="editForm.plan" placeholder="不修改则留空（决定席位与 API 日额度）" allow-clear>
            <a-select-option v-for="p in plans" :key="p.code" :value="p.code">
              {{ p.name }}（{{ p.slot_total }} 席位 · {{ p.price_u }}U）
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="额外席位">
          <a-input-number v-model="editForm.extra_slots" :min="0" :max="999" style="width:100%" placeholder="在套餐席位基础上额外增加" />
          <div style="color:#999;font-size:12px;margin-top:4px;line-height:1.5;">不改套餐、单独加席位。用户可上线域名数 = 套餐席位 + 额外席位。</div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 修改密码 -->
    <a-modal v-model="editPassVisible" title="修改密码" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item ref="name" label="用户密码" prop="password">
          <a-input v-model="editForm.password" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 续期 -->
    <a-modal v-model="editDaysVisible" title="续期" centered cancelText="取消" okText="确认" @ok="editUser">
      <a-form-model :model="form">
        <a-form-model-item label="用户昵称">
          <a-input v-model="editForm.username" disabled="true" @blur="
            () => {
              $refs.name.onFieldBlur();
            }
          " />
        </a-form-model-item>
        <a-form-model-item label="到期时间">
          <div class="quick-time-btns">
            <a-button size="small" @click="setQuickTimeEdit(0.5)">半天</a-button>
            <a-button size="small" @click="setQuickTimeEdit(1)">1天</a-button>
            <a-button size="small" @click="setQuickTimeEdit(7)">1周</a-button>
            <a-button size="small" @click="setQuickTimeEdit(30)">1个月</a-button>
            <a-button size="small" @click="setQuickTimeEdit(90)">3个月</a-button>
          </div>
          <a-date-picker v-model="editForm.days" show-time type="date" placeholder="选择到期时间" style="width: 100%; margin-top: 8px;" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>

  <!-- / Authors Table Card -->
</template>

<script>
import moment from "moment";
import { domainlist, register, updateuser, deleteuser, resetQuota, adminLogin } from "@/api/user";
import { listPlans } from "@/api/plans";

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    this.getAllDoamins();
    this.loadPlans();
  },
  data() {
    return {
      // Active button for the "Authors" table's card header radio button group.
      authorsHeaderBtns: "all",
      modal2Visible: false,
      editUserVisible: false,
      editPassVisible: false,
      editDaysVisible: false,
      domains: [],
      batchDomains: "",   // 编辑域名弹窗：批量新增文本框（一行一个）
      // 域名列默认展示的域名数量，超出折叠为「+N」
      maxVisibleDomains: 2,
      date1: "",
      accountFilter: "all",
      plans: [],
      form: {
        username: "",
        days: "",
        password: "",
        website: [],
        is_sub: false,
        parent: null,
        expiry_time: "",
        plan: "",
        account_type: "normal",
      },
      editForm: {
        username: "",
        website: [],
        password: "",
        days: "",
        expiry_time: "",
        plan: "",
        extra_slots: 0,
        is_sub: false,
        account_type: "normal",
      },
    };
  },
  computed: {
    // 本地化业务空态（替换 ant 默认灰收件箱「暂无数据」）
    tableLocale() {
      const h = this.$createElement
      return {
        emptyText: () => h('div', { class: 'aeg-user-empty' }, [
          h('a-icon', { props: { type: 'usergroup-add' }, class: 'aeg-user-empty-icon' }),
          h('p', { class: 'aeg-user-empty-title' }, '暂无用户'),
          h('p', { class: 'aeg-user-empty-desc' }, '点击右上角「新增用户」创建第一个账号'),
        ]),
      }
    },
    // Compute the data to display based on current page and page size
    displayData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.data.slice(startIndex, endIndex);
    },
    // 获取所有主账号列表
    mainAccounts() {
      return this.data.filter(user => !user.is_sub);
    },
    // 根据筛选条件过滤数据
    filteredData() {
      if (this.accountFilter === 'all') {
        return this.data;
      } else if (this.accountFilter === 'main') {
        return this.data.filter(user => !user.is_sub);
      } else if (this.accountFilter === 'sub') {
        return this.data.filter(user => user.is_sub);
      }
      return this.data;
    },
  },
  watch: {
    date1(newDate) {
      if (newDate) {
        this.calculateDaysDifference(newDate);
      }
    },
  },
  methods: {
    // Handle page change
    handlePageChange(page) {
      this.currentPage = page;
    },
    setModal1Visible(modal1Visible) {
      this.modal1Visible = modal1Visible;
    },
    calculateDaysDifference(date) {
      // 改为传递精确的到期时间字符串，而不是天数差
      const selectedDate = moment(date);
      this.form.expiry_time = selectedDate.format("YYYY-MM-DD HH:mm:ss");
    },
    setQuickTime(mode, days) {
      // 快捷设置到期时间
      // 将天数转换为小时，以支持半天等小数
      const hours = days * 24;
      const targetDate = moment().add(hours, 'hours');
      this.date1 = targetDate;
      this.form.expiry_time = targetDate.format("YYYY-MM-DD HH:mm:ss");
    },
    setQuickTimeEdit(days) {
      // 续期时的快捷时间设置
      // 将天数转换为小时，以支持半天等小数
      const hours = days * 24;
      const targetDate = moment().add(hours, 'hours');
      this.editForm.days = targetDate;
      this.editForm.expiry_time = targetDate.format("YYYY-MM-DD HH:mm:ss");
    },
    getAllDoamins() {
      domainlist().then((res) => {
        this.domains = res.data.available_domains;
      });
    },
    loadPlans() {
      listPlans().then((res) => {
        const list = (res && res.data) ? res.data : [];
        // 只列启用的付费套餐（排除 trial）
        this.plans = list.filter((p) => p.enabled !== 0 && p.code !== "trial");
      }).catch(() => {});
    },
    // 打开「新增用户」弹窗:自动生成一个随机密码,省得手填
    openAddUser() {
      this.form.password = this.genPassword();
      this.modal2Visible = true;
    },
    // 随机密码:aegis 开头 + 8 位随机(去掉易混字符 0/o/1/l/i),好念好抄
    genPassword() {
      const chars = "abcdefghjkmnpqrstuvwxyz23456789";
      let s = "";
      for (let i = 0; i < 8; i++) s += chars.charAt(Math.floor(Math.random() * chars.length));
      return "aegis" + s;
    },
    // 复制登录信息(账号 + 密码),方便直接发给用户
    copyLoginInfo(username, password) {
      const u = (username || "").trim();
      const p = (password || "").trim();
      if (!p) { this.$message.warning("请先生成或填写密码"); return; }
      const text = "账号：" + (u || "(未填写昵称)") + "\n密码：" + p;
      this.copyText(text)
        .then(() => this.$message.success("登录信息已复制"))
        .catch(() => this.$message.error("复制失败，请手动复制"));
    },
    copyText(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise((resolve, reject) => {
        try {
          const ta = document.createElement("textarea");
          ta.value = text; ta.style.position = "fixed"; ta.style.opacity = "0";
          document.body.appendChild(ta); ta.focus(); ta.select();
          document.execCommand("copy"); document.body.removeChild(ta); resolve();
        } catch (e) { reject(e); }
      });
    },
    addUser() {
      if (!this.form.is_sub && !this.form.plan) {
        this.$message.warning("请选择套餐");
        return;
      }
      // 构建请求数据，使用 expiry_time 代替 days
      const requestData = {
        username: this.form.username,
        password: this.form.password,
        website: this.form.website,
        is_sub: this.form.is_sub,
        parent: this.form.parent,
        expiry_time: this.form.expiry_time,
        plan: this.form.plan,
        // 仅主账号带用户类型;子账号无此概念
        account_type: this.form.is_sub ? undefined : (this.form.account_type || 'normal'),
      };
      console.log(requestData);
      register(requestData).then((res) => {
        this.modal2Visible = false;
        this.$message.success("新增用户成功！");
        this.$emit("getUsers");
        // 重置表单
        this.form = {
          username: "",
          days: "",
          password: "",
          website: [],
          is_sub: false,
          parent: null,
          expiry_time: "",
          plan: "",
          account_type: "normal",
        };
        this.date1 = "";
      });
    },
    editUser() {
      let updateForm = {}
      updateForm.username = this.editForm.username;
      
      // 如果有选择到期时间，使用 expiry_time
      if (this.editForm.days != "" && this.editForm.days != null) {
        const selectedDate = moment(this.editForm.days);
        updateForm.expiry_time = selectedDate.format("YYYY-MM-DD HH:mm:ss");
      }
      
      switch (this.modalTitle) {
        case "编辑用户":
          updateForm.website = this.editForm.website
          if (this.editForm.plan) updateForm.plan = this.editForm.plan
          updateForm.extra_slots = this.editForm.extra_slots != null ? this.editForm.extra_slots : 0
          // 主账号才带用户类型
          if (!this.editForm.is_sub) updateForm.account_type = this.editForm.account_type || 'normal'
          break;
        case "编辑密码":
          updateForm.password = this.editForm.password
          break;
      }

      updateuser(updateForm).then((res) => {
        this.editUserVisible = false;
        this.editPassVisible = false;
        this.editDaysVisible = false;
        this.$message.success("修改成功！");
        this.$emit("getUsers");
        // 重置编辑表单
        this.editForm.days = "";
        this.editForm.expiry_time = "";
      });
    },
    deleteUser(row) {
      console.log(row)
      deleteuser({ username: row.username }).then((res) => {
        if (res.status != 200) return this.$message.error("删除失败！");
        this.$message.success("删除成功！");
        this.$emit("getUsers");
      });

    },
    // 重置额度:把该用户今日 API 使用额度清 0
    doResetQuota(row) {
      resetQuota({ username: row.username }).then((res) => {
        if (res && res.status === 200) {
          const before = (res.data && res.data.before != null) ? res.data.before : 0;
          this.$message.success(`已重置 ${row.username} 今日额度（清 0 前已用 ${before}）`);
          this.$emit("getUsers");
        } else {
          this.$message.error((res && res.message) || "重置失败");
        }
      }).catch((e) => {
        this.$message.error((e && e.data && e.data.message) || "重置失败，请重试");
      });
    },
    openEdit(row) {

      this.modalTitle = "编辑用户";
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editForm.username = row.username;
      this.editForm.plan = row.plan || "";
      this.editForm.extra_slots = (row.extra_slots != null && row.extra_slots !== '') ? Number(row.extra_slots) : 0;
      this.editForm.is_sub = !!row.is_sub;
      this.editForm.account_type = row.account_type === 'agent' ? 'agent' : 'normal';
      this.batchDomains = "";
      this.editUserVisible = true;
    },
    // 批量新增：文本框一行一个域名，去重合并进「分配域名」；不在下拉选项里的也补进 domains 以便正常显示
    batchAddDomains() {
      const raw = (this.batchDomains || "").split(/[\r\n]+/)
        .map(s => s.trim().replace(/^https?:\/\//i, "").replace(/\/+$/,"").toLowerCase())
        .filter(Boolean);
      if (!raw.length) { this.$message.warning("请先在文本框里粘贴域名（一行一个）"); return; }
      const cur = Array.isArray(this.editForm.website) ? this.editForm.website.slice() : [];
      const curSet = new Set(cur);
      const optSet = new Set(this.domains);
      let added = 0;
      raw.forEach(d => {
        if (!curSet.has(d)) { cur.push(d); curSet.add(d); added++; }
        if (!optSet.has(d)) { this.domains.push(d); optSet.add(d); }
      });
      this.editForm.website = cur;
      this.batchDomains = "";
      this.$message.success(added > 0 ? `已加入 ${added} 个域名授权` : "没有新增（都已在授权列表里）");
    },
    openEditPass(row) {
      this.modalTitle = "编辑密码";
      this.editForm.username = row.username;
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editPassVisible = true
    },
    openEditDays(row) {
      this.modalTitle = "续期";
      this.editForm.username = row.username;
      this.editForm.website = row.website.length ? row.website.split(",") : [];
      this.editDaysVisible = true
    },
    isExpiringSoon(expiry_time_str) {
      // 将到期时间字符串转换为日期对象
      let expiryDate = new Date(expiry_time_str);

      // 获取当前时间
      let currentDate = new Date();

      // 计算到期时间与当前时间的时间差（毫秒数）
      let timeDifference = expiryDate.getTime() - currentDate.getTime();

      // 将时间差转换为天数
      let daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

      // 判断是否低于7天
      return daysDifference < 7;
    },
    truePass(row) {
      adminLogin({ username: row.username }).then(res => {
        if (res.status == 200) {
          const token = res.data.token
          window.open(process.env.VUE_APP_URL.replace("/api","/dashboard") + "?token=" + token)
        }

      })
    },
    // 把 website 字符串拆成去空非空的域名数组
    domainList(website) {
      if (!website) return [];
      return String(website)
        .split(",")
        .map((d) => d.trim())
        .filter((d) => d.length);
    },
    // 单元格内默认展示的域名（前 2 个），其余折叠
    visibleDomains(website) {
      return this.domainList(website).slice(0, this.maxVisibleDomains);
    },
    // 被折叠的域名（用于「+N」计数与气泡）
    hiddenDomains(website) {
      return this.domainList(website).slice(this.maxVisibleDomains);
    },
    copyDomain(domain) {
      navigator.clipboard.writeText(domain).then(() => {
        this.$message.success('域名已复制到剪贴板');
      }).catch(() => {
        this.$message.error('复制失败，请手动复制');
      });
    },
    onAccountTypeChange(e) {
      // 当账号类型改变时，清空父账号选择
      if (!e.target.value) {
        this.form.parent = null;
      }
    },
    onFilterChange(value) {
      // 筛选条件变化时的处理
      this.accountFilter = value;
    },
  },
  mounted() {
    this.getAllDoamins();
  },
};
</script>
<style lang="css" scoped>
.btn-edit {
  color: blue;
}

/* 新增用户表单：横向布局 + 缩小行间距，让整个表单一屏放得下，不用下拉 */
.au-form >>> .ant-form-item {
  margin-bottom: 12px;
}
.au-form >>> .ant-form-item:last-child {
  margin-bottom: 0;
}

/* 操作列：5 个动作单行不换行，行高回落到常规单行 */
.action-cell {
  white-space: nowrap;
}

/* 收紧 link 按钮的左右内边距，使 5 个动作在 ~280px 列宽内单行排布 */
.action-cell .action-link {
  padding-left: 4px;
  padding-right: 4px;
  height: auto;
}

.text-red {
  color: red;
}

.website-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.website-tag {
  cursor: pointer;
  margin: 0;
  max-width: 160px;
  padding: 2px 8px;
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: all 0.3s;
}

.website-tag:hover {
  opacity: 0.8;
}

/* 「+N」折叠标签：低饱和底色，与域名蓝标区分 */
.website-more-tag {
  max-width: none;
  background: #f0f0f0;
  border-color: #d9d9d9;
  color: #595959;
  font-weight: 600;
}

/* 折叠气泡内的完整域名列表，竖向排布，限制高度避免过长 */
.website-overflow-pop {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  max-width: 280px;
  max-height: 320px;
  overflow-y: auto;
}

.website-overflow-pop .website-tag {
  max-width: 260px;
  /* 关键修复：flex column 下多域名时标签会被压扁导致文字看不到，禁止收缩、保持自然高度，超出则滚动 */
  flex-shrink: 0;
  height: auto;
  line-height: 22px;
  white-space: nowrap;
}

/* 新增样式 */
.username-info {
  display: flex;
  align-items: center;
}

.username-text {
  font-weight: 500;
  color: #333;
}

.username-text.sub-account {
  color: #fa8c16;
  font-style: italic;
}

.account-type-tag {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
}

.account-type-tag .anticon {
  font-size: 12px;
}

.parent-info {
  display: flex;
  align-items: center;
}

.parent-username {
  color: #1890ff;
  font-weight: 500;
  background: #f0f8ff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}

.no-parent {
  color: #999;
  font-style: italic;
}

.quick-time-btns {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.quick-time-btns .ant-btn {
  border-radius: 4px;
}
</style>
<!-- 空态由 render 函数生成，scoped 属性不会注入，故用全局样式 -->
<style lang="css">
.aeg-user-empty { padding: 32px 16px; text-align: center; color: #8c8c8c; }
.aeg-user-empty-icon { font-size: 40px; color: #bfbfbf; margin-bottom: 12px; }
.aeg-user-empty-title { margin: 0 0 4px; font-size: 15px; font-weight: 600; color: #595959; }
.aeg-user-empty-desc { margin: 0; font-size: 13px; color: #8c8c8c; }
</style>
